'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isSameMonth = {};

exports.__exports = isSameMonth;
